import React, { useEffect } from "react";
import Card from "components/card";
import { Form } from 'antd';
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { renderLabel } from '../../../../utils/index';
import { useForm } from 'antd/lib/form/Form';
import { useParams } from 'react-router-dom';
import { 
	getAccountDetails
} from "../../../../redux/account/accountState";

const AccountHeader = ({getRecord, recordData, ...props}) => {
	const { accountId } = useParams();

	useEffect(() => {
			getRecord(accountId);
		}, [accountId, getRecord]);
	
  	return (
    	<Card extra={"w-full h-full p-4"}>
		  	<Form className="form"
		  		layout="vertical"
	        >   
        		<div className="form-column-4">         
					<FormItem extra="col-span-1 md:col-span-2"
		            	name="name"
		                label="Client Name"
		            >
		            	{renderLabel(recordData?.name)}
	            	</FormItem>
	 			</div>
	 		</Form>	 	
	 	</Card>
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.account.details?.data,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getAccountDetails(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountHeader);
